import { render } from "./DocumentacionPage.vue?vue&type=template&id=0fbb2892&scoped=true"
import script from "./DocumentacionPage.vue?vue&type=script&lang=js"
export * from "./DocumentacionPage.vue?vue&type=script&lang=js"

import "./DocumentacionPage.vue?vue&type=style&index=0&id=0fbb2892&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fbb2892"]])

export default __exports__